import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import {
  Paper,
  PaperHeadline,
  Text,
  PaperContent,
  Option,
  Divider,
  Icon
} from '../..';

export class PlanCard extends Component {
  static propTypes = {
    price: PropTypes.string,
    plan: PropTypes.string,
    deductible: PropTypes.string,
    limit: PropTypes.string,
    reimbursement: PropTypes.string,
    coverageText: PropTypes.string,
    optionLabel: PropTypes.string,
    optionActive: PropTypes.bool,
    selectPlanProps: PropTypes.func,
    planDetails: PropTypes.string,
    id: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object,
    refProp: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.shape({ current: PropTypes.instanceOf(Element) })
    ])
  }

  static defaultProps = {
    
  }

  render() {
    const {
      price,
      plan,
      deductible,
      limit,
      reimbursement,
      coverageText,
      optionLabel,
      optionActive,
      selectPlanProps,
      planDetails,
      id,
      className,
      style,
      refProp
    } = this.props;

    const modifiedPrice = price?.split('.');
    return (
      <div className={cn('ui-pet-best-insurance-card__plan', className)}>
        {/* Change it later. */}
        {/* {item === 2 && (<PaperHeadline className='ui-pet-best-insurance-card__popular'>
          <div>
            <Icon type='star' />
            <span>Most Popular</span>
          </div>
        </PaperHeadline>)} */}
        <div className='ui-pet-best-insurance-card__main'>
          <div>
            <div className='ui-pet-best-insurance-card__content'>
              <Text>{plan}</Text>
              <div className='ui-pet-best-insurance-card__price'>
                <Text className='ui-pet-best-insurance-card__price-value'>
                  {modifiedPrice[0]}
                  {modifiedPrice?.[1] && (<sup>.{modifiedPrice[1]}</sup>)}
                </Text>
                <Text className='ui-pet-best-insurance-card__frequency'>/month</Text>
              </div>
            </div>
            <Text className='ui-pet-best-insurance-card__label'>
                {planDetails}
            </Text>
          </div>

          <div className='ui-pet-best-insurance-card__details'>
            <div>
              <Text className='ui-pet-best-insurance-card__title'>Deductible</Text>
              <Text className='ui-pet-best-insurance-card__info'>{deductible}</Text>
            </div>
            <div>
              <Text className='ui-pet-best-insurance-card__title'>Limit</Text>
              <Text>{limit}</Text>
            </div>
            <div>
              <Text className='ui-pet-best-insurance-card__title'>Reimbursement Level</Text>
              <Text>{reimbursement}</Text>
            </div>
          </div>

          <div className='ui-pet-best-insurance-card__coverage'>
            <Text className='ui-pet-best-insurance-card__title'>What’s Covered</Text>
            <div className="ui-pet-best-insurance-card__benefits">
              <Icon type='done' />
              <span>{coverageText}</span>
            </div>
          </div>

          <div className={cn("ui-pet-best-insurance-card__add_cta")}>
            <Option
              // id={`${productName.replaceAll(' ', '-')}-Option`}
              label={optionActive
                ? (<div className="ui-new-purchase-plan-card__add_to_cart">
                  <Icon type='done' />
                  <span>Selected</span>
                </div>)
                : "Select"}
              active={optionActive}
              onClick={selectPlanProps}
            />
          </div>
        </div>
      </div>
    )
  }
}